import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatMenuModule } from '@angular/material/menu'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatSelectModule } from '@angular/material/select'
import { MatTooltipModule } from '@angular/material/tooltip'
import { RouterModule } from '@angular/router'
import { PipesModule } from '@mmx/pipes'
import { DirectivesModule } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'

import { CopyTextModule } from '../copy-text'
import { SendContactEditDialogModule } from '../send-contact-edit-dialog'
import { CustomQuestionComponent } from './custom-question/custom-question.component'
import { IntakeCardComponent } from './intake-card.component'

@NgModule({
  imports: [
    CommonModule,
    CopyTextModule,
    DirectivesModule,
    SendContactEditDialogModule,
    FlexLayoutModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatCardModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatProgressBarModule,
    MatSelectModule,
    MatTooltipModule,
    ReactiveFormsModule,
    PipesModule,
    RouterModule,
    TranslateModule,
  ],
  exports: [
    CustomQuestionComponent,
    IntakeCardComponent,
  ],
  declarations: [
    CustomQuestionComponent,
    IntakeCardComponent,
  ],
  providers: [],
})
export class IntakeCardModule { }
